export { default as AdminListListItemHeadMobile } from './AdminListListItemHeadMobile';

export type {
  AdminListListItemHeadMobileProps,
  AdminListListItemHeadMobileComponent,
} from './AdminListListItemHeadMobile.type';
